import React, { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import type { UiWalletAccount } from "@wallet-standard/react"
import { useViewerMaybe } from "~/auth/use-viewer"
import { rootPath } from "~/common/paths"
import { SolanaWalletConnect } from "~/solana/components/SolanaWalletConnect"
import { LoginScreenLayout } from "~/ui/login-screen-layout"
import { useToast } from "~/ui/use-toast"

export const SolanaLoginScreen: React.FC = () => {
  const navigate = useNavigate()
  const { toast } = useToast()
  const {
    result: { refetch: refetchViewer },
  } = useViewerMaybe()

  const handleSuccess = useCallback(
    async (_account: UiWalletAccount | undefined) => {
      await refetchViewer()

      toast({
        title: "Login Successful",
        description: "You have been successfully logged in.",
        variant: "default",
      })
      navigate(rootPath({}))
    },
    [refetchViewer, navigate, toast]
  )

  return (
    <LoginScreenLayout
      headerSubtitle="Get Started"
      headerTitle="Sign in with your wallet"
      testId="solana-login-screen"
    >
      <SolanaWalletConnect mode="signin" onSuccess={handleSuccess} />
    </LoginScreenLayout>
  )
}
